import { Box, Typography } from "@mui/material";
import { Property } from "../../types";
import SubPropertyCollapsibleCard from "../property/collapsible-card/collapsible-card";
import AddSubProperty from "./add-sub-property";
import SubPropertiesEmptyState from "./empty-state";
import { useSubpropertiesQuery } from "../../hooks/sub-properties.hook";
import LoadingSkeleton from "@/modules/common/components/ui/loadingSkeleton";

export default function SubPropertiesTab({
  property,
  trackTypeName,
}: {
  property: Property;
  trackTypeName?: string;
}) {
  const { data: subProperties, isLoading } = useSubpropertiesQuery({
    uid: property.uid,
  });

  const hasSubProperties = subProperties && subProperties.length > 0;

  if (isLoading) return <LoadingSkeleton heights={["100"]} rows={3} />;

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      {hasSubProperties ? (
        <>
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: theme.nawy.spacing.md,
              backgroundColor: theme.nawy.colors.semantic.layer.primary,
              borderRadius: theme.nawy.radius.xl,
            })}
          >
            <Box
              sx={(theme) => ({
                display: "flex",
                alignItems: "baseline",
                gap: theme.nawy.spacing.xxs,
              })}
            >
              <Typography
                sx={(theme) =>
                  theme.nawy.typography.english.variants.headline.sm
                }
              >
                Sub-Properties
              </Typography>
              <Typography
                sx={(theme) =>
                  theme.nawy.typography.english.variants.body.sm.regular
                }
              >
                ({subProperties?.length ?? 0})
              </Typography>
            </Box>
            {hasSubProperties && (
              <AddSubProperty
                property={property}
                trackTypeName={trackTypeName}
              />
            )}
          </Box>

          <Box
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              gap: theme.nawy.spacing.md,
              py: theme.nawy.spacing.md,
            })}
          >
            {subProperties.map((property) => (
              <SubPropertyCollapsibleCard property={property} />
            ))}
          </Box>
        </>
      ) : (
        <SubPropertiesEmptyState property={property} trackTypeName={trackTypeName} />
      )}
    </Box>
  );
}
